const replaceShortcodes = (shortCodes) => (string) => {
  let text = string;
  return shortCodes.reduce((acc, obj) => {
    const { regex, value } = obj;
    return acc.replace(regex, value);
  }, text);
};

export default replaceShortcodes;
